import { INVOICING_HELPER_ARTICLE_ID } from "@shared/features/settings/subscription/constants";
import { HelperTooltip } from "common/Tooltips/HelperTooltip";
import { AnalyticsPageName, LanguageNameSpaces } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

const InvoicingHelperTooltip = () => {
  const { t } = useTypedTranslation(LanguageNameSpaces.COMMON);

  return (
    <HelperTooltip
      analyticsPageName={AnalyticsPageName.BILLING}
      analyticsFieldName={t("tooltips.invoicing_title")}
      description={t("tooltips.invoicing_description")}
      articleId={INVOICING_HELPER_ARTICLE_ID}
      containerStyle={{ marginLeft: 6 }}
      maxWidth={300}
    />
  );
};

export default InvoicingHelperTooltip;
